// extracted by mini-css-extract-plugin
export default {"layoutWrap":"style_layoutWrap__gahbR","content":"style_content__2i-Wx","full":"style_full__I-A-3"};